// View Component: Footer bölümü
import React from "react";
import { AppConstants } from "../../models/AppData";

const Footer = () => {
  const footerStyles = {
    backgroundColor: "var(--gray-900)",
    color: "#FFFFFF",
    padding: "var(--spacing-6xl) 0 var(--spacing-2xl)",
  };

  const containerStyles = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 var(--spacing-lg)",
  };

  const contentStyles = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "var(--spacing-4xl)",
    marginBottom: "var(--spacing-5xl)",
  };

  const brandStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "var(--spacing-lg)",
  };

  const logoStyles = {
    display: "flex",
    alignItems: "center",
    gap: "var(--spacing-md)",
    fontSize: "24px",
    fontWeight: "700",
    fontFamily: "var(--font-secondary)",
  };

  const logoIconStyles = {
    fontSize: "32px",
  };

  const descriptionStyles = {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#D1D5DB",
    maxWidth: "300px",
  };

  const sectionTitleStyles = {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "var(--spacing-lg)",
    color: "#FFFFFF",
  };

  const linkListStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "var(--spacing-md)",
  };

  const linkStyles = {
    color: "#D1D5DB",
    fontSize: "16px",
    textDecoration: "none",
    transition: "color 300ms ease",
    cursor: "pointer",
  };

  const bottomBarStyles = {
    borderTop: "1px solid #374151",
    paddingTop: "var(--spacing-2xl)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "var(--spacing-lg)",
  };

  const copyrightStyles = {
    fontSize: "14px",
    color: "#9CA3AF",
  };

  const socialLinksStyles = {
    display: "flex",
    gap: "var(--spacing-lg)",
  };

  const socialLinkStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    backgroundColor: "#374151",
    borderRadius: "50%",
    color: "#D1D5DB",
    textDecoration: "none",
    transition: "all 300ms ease",
    fontSize: "20px",
  };

  const handleLinkHover = (e) => {
    e.target.style.color = "var(--color-primary)";
  };

  const handleLinkLeave = (e) => {
    e.target.style.color = "#D1D5DB";
  };

  const handleSocialHover = (e) => {
    e.target.style.backgroundColor = "var(--color-primary)";
    e.target.style.color = "#FFFFFF";
  };

  const handleSocialLeave = (e) => {
    e.target.style.backgroundColor = "#374151";
    e.target.style.color = "#D1D5DB";
  };

  return (
    <footer style={footerStyles}>
      <div style={containerStyles}>
        <div style={contentStyles}>
          {/* Marka Bilgileri */}
          <div style={brandStyles}>
            <div style={logoStyles}>
              <span style={logoIconStyles}>🧠</span>
              {AppConstants.APP_NAME}
            </div>
            <p style={descriptionStyles}>{AppConstants.APP_DESCRIPTION}</p>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h4 style={sectionTitleStyles}>Quick Links</h4>
            <div style={linkListStyles}>
              <a
                href="#features"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Features
              </a>
              <a
                href="#testimonials"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Testimonials
              </a>
              <a
                href="#faq"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                FAQ
              </a>
            </div>
          </div>

          {/* Yasal */}
          <div>
            <h4 style={sectionTitleStyles}>Legal</h4>
            <div style={linkListStyles}>
              <a
                href="/privacy.html"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Privacy Policy
              </a>
              <a
                href="/terms.html"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Terms of Service
              </a>
              <a
                href="/cookies.html"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Cookie Policy
              </a>
            </div>
          </div>

          {/* Destek */}
          <div>
            <h4 style={sectionTitleStyles}>Support</h4>
            <div style={linkListStyles}>
              <a
                href="mailto:support@zoeadhd.com"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Technical Support
              </a>
              <a
                href="/help"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                Help Center
              </a>
              <a
                href="/docs"
                style={linkStyles}
                onMouseEnter={handleLinkHover}
                onMouseLeave={handleLinkLeave}
              >
                User Guide
              </a>
            </div>
          </div>
        </div>

        {/* Alt Bar */}
        <div style={bottomBarStyles}>
          <div style={copyrightStyles}>
            © 2025 {AppConstants.COMPANY_NAME}. All rights reserved.
          </div>

          <div style={socialLinksStyles}>
            <a
              href="#"
              style={socialLinkStyles}
              onMouseEnter={handleSocialHover}
              onMouseLeave={handleSocialLeave}
              aria-label="Twitter"
            >
              🐦
            </a>
            <a
              href="#"
              style={socialLinkStyles}
              onMouseEnter={handleSocialHover}
              onMouseLeave={handleSocialLeave}
              aria-label="LinkedIn"
            >
              💼
            </a>
            <a
              href="#"
              style={socialLinkStyles}
              onMouseEnter={handleSocialHover}
              onMouseLeave={handleSocialLeave}
              aria-label="Instagram"
            >
              📷
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
